import CityPageTemplate from "../city-template/CityPageTemplate";
import { owensboroConfig } from "./data";

export default function OwensboroPage() {
  return <CityPageTemplate config={owensboroConfig} />;
}